module.exports = __webpack_public_path__ + "static/media/logo-grabpay.0d10fbe9.png";